import {createContext, useContext, useReducer} from 'react';

const initialState = {
  isOpen: false,
};

function reducer(state, action) {
  switch (action.type) {
    case 'TOGGLE':
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    default:
      return state;
  }
}

const HeaderDrawerStateContext = createContext(initialState);

const HeaderDrawerDispatchContext = createContext(undefined);

export const HeaderDrawerProvider = ({children}) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <HeaderDrawerStateContext.Provider value={state}>
      <HeaderDrawerDispatchContext.Provider value={dispatch}>{children}</HeaderDrawerDispatchContext.Provider>
    </HeaderDrawerStateContext.Provider>
  );
};

export function useHeaderDrawerState() {
  const context = useContext(HeaderDrawerStateContext);

  if (context === undefined) {
    throw new Error(`useHeaderDrawerState must be used inside a HeaderDrawerProvider`);
  }

  return context;
}

export function useHeaderDrawerDispatch() {
  const context = useContext(HeaderDrawerDispatchContext);

  if (context === undefined) {
    throw new Error(`useHeaderDrawerDispatch must be used inside a HeaderDrawerProvider`);
  }

  return context;
}
